/** experiment ids go here */
export const EXP_039_ACCESSORIES_PAGE = 'exp_039_accessories_page';
